export default {

    // 清除：所有数据
    initClearData(state, value) {
        state.accountData = value;
    },
    // 存入：当前选中的地址 编码
    initAccountData(state, value){
        state.accountData = value;
    },

    // 存入：全局消息
    initNoticeData(state, value){
        state.noticeData = value;
    },

    // 存入：当前选中的地址 编码
    initAddressCode(state, value){
        state.addressCode = value;
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js